import type { ExecutionState } from "../types";

/**
 * The only `awaiting_user` phases where the USER must act: the deposit intent
 * waiting for the user's transfer, and the legacy engine's signature wait.
 * Unknown phases default away from action-required treatment.
 */
const GENUINE_ACTION_PHASES = new Set([
  "awaiting_transaction",
  "awaiting_signature",
]);

export type AwaitingUserClassification = "action_required" | "parked";

export function classifyAwaitingUserPhase(
  phase: string | null | undefined,
): AwaitingUserClassification {
  return phase && GENUINE_ACTION_PHASES.has(phase)
    ? "action_required"
    : "parked";
}

/**
 * A parked execution has exhausted its fast settlement budget and handed
 * monitoring to reconciliation. Parked toasts auto-dismiss into watching
 * instead of spinning forever.
 */
export function isParkedExecution(
  _state: ExecutionState | null | undefined,
  phase: string | null | undefined,
): boolean {
  return phase === "settlement_delayed";
}

export function isActionRequiredExecution(
  state: ExecutionState | null | undefined,
  phase: string | null | undefined,
): boolean {
  return (
    state === "awaiting_user" &&
    classifyAwaitingUserPhase(phase) === "action_required"
  );
}
